import * as React from 'react';

import {GridList} from 'shells/grid-list/grid-list';
import {OptionCardChooser} from 'shells/option-card-chooser/option-card-chooser';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {Subheader} from 'shells/typography/subheader';

import {appHistory} from '../../../../../history';

import type {Page} from '../unsubscribe-modal';

type Props = {
    onSelectImportType: (selectedPage: Page) => void;
};

export function Home(props: Props) {
    return (
        <React.Fragment>
            <SpacerGroup mb={8}>
                <Subheader>
                    Adding unsubscribe statuses to your people will increase your email delivery
                    rates.
                </Subheader>
            </SpacerGroup>
            <GridList numColumns={2}>
                <OptionCardChooser
                    key='peopleList'
                    onClick={() => {
                        NutClientConfig.shouldShowImportUnsubscribesOnboardingModal = true;
                        appHistory.push('/people');
                    }}
                    illustration='audience-people'
                    title='People list'
                    subtitle='Add unsubscribes using data already stored inside of Nutshell'
                />
                <OptionCardChooser
                    key='csv'
                    onClick={() => props.onSelectImportType('csv')}
                    illustration='import-spreadsheet'
                    title='CSV Spreadsheet'
                    subtitle='Add unsubscribes from Microsoft Excel, Google Sheets, or any CSV spreadsheet'
                />
                <OptionCardChooser
                    key='mailchimp'
                    onClick={() => props.onSelectImportType('mailchimp')}
                    illustration='import-mailchimp'
                    title='MailChimp'
                    subtitle='Import unsubscribes from MailChimp using your exported file'
                />
                <OptionCardChooser
                    key='ctct'
                    onClick={() => props.onSelectImportType('ctct')}
                    illustration='import-constant-contact'
                    title='Constant Contact'
                    subtitle='Import unsubscribes from Constant Contact using your exported file'
                />
            </GridList>
        </React.Fragment>
    );
}
